import { useQuery } from '@tanstack/react-query'

import { axiosInstance } from '../axios'

function groupBy(array, keyFn) {
  return array.reduce((acc, item) => {
    const key = keyFn(item)
    ;(acc[key] ||= []).push(item)
    return acc
  }, {})
}

export function GetCategoryList() {
  return useQuery({
    queryKey: ['category', 'list'],
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    queryFn: async () => {
      try {
        const { list } = await axiosInstance.get('/category')
        // es2024
        // const data = Object.groupBy(list, ({ type }) => type)
        const data = groupBy(list, item => item.type)

        const dataSource = Object.entries(data).map(([entry1, entry2]) => {
          const categories = entry2.map(({ id, key }) => ({
            id,
            key: id,
            i18nKey: `category.${key}`,
          }))
          return {
            id: entry1,
            i18nKey: `categoryType.${entry1}`,
            categories,
          }
        })
        const sexualCategories = list
          .filter(item => item.type === 'Sexual')
          .map(item => ({ ...item, i18nKey: `category.${item.key}` }))
        const sexualCategoryIds = sexualCategories.map(item => item.id)
        return {
          list,
          dataSource,
          sexualCategories,
          sexualCategoryIds,
        }
      } catch (error) {
        console.error(error)
      }
      return []
    },
  })
}
